import React from 'react';
import './App.css';
import {Outlet, RouterProvider} from "react-router-dom";
import router from './router/appRouter';
import { AppContextProvider } from './contexts/appContext/app.context';

function App() {
    return (
        <AppContextProvider>
            <div className="app-wrapper">
                <RouterProvider router={router}/>
                <Outlet/>
            </div>
        </AppContextProvider>
    );
}

export default App;
